import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Typography,
  Divider,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import { useStyles } from "./styles";

const ProgramAccordionItem = ({
  row,
  colorIndex,
  getColorClass,
  formatDate,
  expanded,
  onChange,
}) => {
  const classes = useStyles();
  const hasNotSchedule = row.hora_inicio === "00:00:00" || !row.hora_inicio;

  return (
    <Accordion 
      className={classes.root}
      expanded={expanded}
      onChange={onChange}
    >
      <AccordionSummary
        className={classes.summary}
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`accordion-content-${row.titulo}`}
        id={`accordion-header-${row.titulo}`}
      >
        <Grid className={classes.content}>
          {row.data_atividade && (
            <>
              <Grid className={classes.dateContainer}>
                <div className={`${classes.dayMonth} ${getColorClass(colorIndex)}`}>
                  <Typography className={classes.day}>
                    {formatDate.getDay(row.data_atividade)}
                  </Typography>
                  <Typography className={classes.month}>
                    {formatDate.monthInFull(row.data_atividade).slice(0, 3)}
                  </Typography>
                </div>
              </Grid>
              <Divider orientation="vertical" className={classes.divider} />
            </>
          )}

          {!hasNotSchedule && (
            <>
              <Grid className={classes.schedule}>
                <AccessTimeIcon fontSize="small" />
                <Typography>
                  {formatDate.hour(row.hora_inicio)} -{" "}
                  {formatDate.hour(row.hora_fim)}
                </Typography>
              </Grid>
              <Divider orientation="vertical" className={classes.divider} />
            </>
          )}

          <Typography className={classes.title}>{row.titulo}</Typography>
        </Grid>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <Grid className={classes.occupations}>
          {row.custom.map((customAttribute, idx) => (
            <div key={idx}>
              {customAttribute.funcao && customAttribute.nome_palestrante && (
                <Typography className={classes.profile}>
                  <strong>{`${customAttribute.funcao}: `}</strong>
                  {`${customAttribute.nome_palestrante}`}
                </Typography>
              )}
            </div>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default ProgramAccordionItem;
